import { Component } from 'react'
import { DropTarget } from 'react-dnd'
import { HIGHLIGHT } from '../../constants/itemTypes'

const ConditionalWrapper = ({ display, wrapper, children }) => wrapper ? wrapper(children, display) : children

const itemTarget = {
	drop(props, monitor, component ) {
		const { listID, items } = props
		const sourceObj = monitor.getItem()

		if(listID !== sourceObj.listID && !_.find(items, item => item.id === sourceObj.id)) {
			props.pushItem(listID, sourceObj.id, sourceObj.type)
		}
		
		return {
			listID: listID,
		}
	},
	canDrop(props, monitor) {
		if(props.canDropCallback) {
			return props.canDropCallback(props, monitor.getItem())
		} else if(props.items.length > 0 && props.selectionType === HIGHLIGHT) {
			return false
		} else {
			return true
		}
	} 
}

@DropTarget(props => (props.dndType), itemTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
	canDrop: !!monitor.canDrop(),
}))

class DropTargetWrapperContainer extends Component {
	render() {
		const { children, connectDropTarget, isOver, canDrop, selectionType} = this.props
		const wrapper = this.props.hasOwnProperty('wrapper') && typeof this.props.wrapper === "function" ? this.props.wrapper : false
		const canDropClass =  canDrop && isOver ? ' can-drop' : ''
		const cannotDropClass =  isOver && !canDrop ? ' can-not-drop' : ''

		return (
			<ConditionalWrapper
				display={selectionType === HIGHLIGHT ? canDrop : selectionType === 'newsletter' ? canDrop : true}
				wrapper={wrapper}
			>
				{connectDropTarget(
					<div className={"item-drag-container" + cannotDropClass + canDropClass}>
						{children}
					</div>
				)}
			</ConditionalWrapper>
		)
	}
}

export default DropTargetWrapperContainer